import { cities } from '../Utils/helper';

export const HealthPages = () => {
  return cities.map((city) => `/ivf-centers-in-${city}`);
};
export const StaticPages = [
  '/store',
  '/care',
  '/parenting/babynames',
  '/topics',
  '/essentials',
  '/veda',
  '/about-mylo',
  '/tools/duedatecalculator',
  '/tools ',
  '/taglist',
  '/terms-of-use',
  '/refund-cancellation',
  '/privacy-policy',
  '/pregnancy',
  '/partner-with-us ',
];
export const productCategoryUrls = [
  // {
  //     url: "/product-category/baby-soap",
  //     date: "2024-03-21T16:24:22.840Z",
  //     images: [
  //         "https://images.myloapp.in/NestJsUploads/1710174592354-Baby-Soap---75-gm.webp",
  //     ],
  // },
  // {
  //     url: "/product-category/baby-shampoo",
  //     date: "2024-03-21T16:24:22.840Z",
  //     images: [
  //         "https://images.myloapp.in/NestJsUploads/1710938559026-Baby-Body-Wash-and-Shampoo---200-ml.webp",
  //         "https://images.myloapp.in/NestJsUploads/1710938971378-Baby-Body-Wash-and-Shampoo---200-ml-and-Baby-Lotion-200-ml-(Pack-of-2).webp",
  //     ],
  // },
  {
    url: '/product-category/baby-lotion',
    date: '2024-03-21T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1710932941020-Baby-Lotion-for-Kids---200-ml.webp',
    ],
  },
  {
    url: '/product-category/baby-powder',
    date: '2024-03-21T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1710175805548-Baby-Powder-for-Kids---300-gm.webp',
    ],
  },
  {
    url: '/product-category/baby-body-wash',
    date: '2024-03-21T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1710938559026-Baby-Body-Wash-and-Shampoo---200-ml.webp',
      'https://images.myloapp.in/NestJsUploads/1710938971378-Baby-Body-Wash-and-Shampoo---200-ml-and-Baby-Lotion-200-ml-(Pack-of-2).webp',
    ],
  },
  // {
  //     url: "/product-category/stretch-marks-cream",
  //     date: "2024-03-21T16:24:22.840Z",
  //     images: [
  //         "https://images.myloapp.in/NestJsUploads/1710920903015-Stretch-Marks-Cream---100-gm.webp",
  //     ],
  // },
  {
    url: '/product-category/stretch-marks-oil',
    date: '2024-03-21T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1710921226383-Stretch-Marks-Oil---100-ml.webp',
    ],
  },
  // {
  //     url: "/product-category/baby-cream",
  //     date: "2024-03-21T16:24:22.840Z",
  //     images: [
  //         "https://images.myloapp.in/NestJsUploads/1710175805548-Baby-Cream-for-Face---100-gm.webp",
  //     ],
  // },
  {
    url: '/product-category/baby-massage-oil',
    date: '2024-03-21T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1710175973777-Baby-Massage-Oil---200ml.webp',
    ],
  },
  {
    url: '/product-category/baby-hair-oil',
    date: '2024-03-27T16:24:22.840Z',
    images: [
      'https://images.myloapp.in/NestJsUploads/1711535527208-Baby_hair_oil.webp',
    ],
  },
];
export const productCategory = productCategoryUrls?.map((item) => item.url);

export const productCategoryArticle = [
  {
    icon: 'https://images.myloapp.in/NestJsUploads/1710174592354-Baby-Soap---75-gm.webp',
    key: '/product-category/baby-soap',
    tabName: 'Baby Soap',
  },
  {
    icon: 'https://images.myloapp.in/NestJsUploads/1710938559026-Baby-Body-Wash-and-Shampoo---200-ml.webp',
    key: '/product-category/baby-shampoo',
    tabName: 'Baby Shampoo',
  },
  {
    icon: 'https://images.myloapp.in/NestJsUploads/1710932941020-Baby-Lotion-for-Kids---200-ml.webp',
    key: '/product-category/baby-lotion',
    tabName: 'Baby Lotion',
  },
  {
    icon: 'https://images.myloapp.in/NestJsUploads/1711535527208-Baby_hair_oil.webp',
    key: '/product-category/baby-hair-oil',
    tabName: 'Baby Hair Oil',
  },
];

export const productCategoryArticleFront = [
  {
    key: '/product-category/baby-powder',
    tabName: 'Baby Powder',
    icon: 'https://images.myloapp.in/NestJsUploads/1710175805548-Baby-Powder-for-Kids---300-gm.webp',
  },
  {
    key: '/product-category/baby-body-wash',
    tabName: 'Baby Body Wash',
    icon: 'https://images.myloapp.in/NestJsUploads/1710938559026-Baby-Body-Wash-and-Shampoo---200-ml.webp',
  },
  {
    key: '/product-category/stretch-marks-cream',
    tabName: 'Stretch Marks Cream',
    icon: 'https://images.myloapp.in/NestJsUploads/1710920903015-Stretch-Marks-Cream---100-gm.webp',
  },
  {
    key: '/product-category/stretch-marks-oil',
    tabName: 'Stretch Marks Oil',
    icon: 'https://images.myloapp.in/NestJsUploads/1710921226383-Stretch-Marks-Oil---100-ml.webp',
  },
  {
    key: '/product-category/baby-cream',
    tabName: 'Baby Cream',
    icon: 'https://images.myloapp.in/NestJsUploads/1710175805548-Baby-Cream-for-Face---100-gm.webp',
  },
  {
    key: '/product-category/baby-massage-oil',
    tabName: 'Baby Massage Oil',
    icon: 'https://images.myloapp.in/NestJsUploads/1710175973777-Baby-Massage-Oil---200ml.webp',
  },
];

export const getStaticPagesData = (data_type) => {
  let static_data = [];
  switch (data_type) {
    case 'Static':
      static_data = StaticPages;
      break;
    case 'Health':
      static_data = HealthPages();
      break;
    case 'productCategory':
      static_data = productCategory;
      break;
  }
  return static_data.map((url) => {
    return { web_url: url };
  });
};

export const getTitleFromUrl = (url, onlyLastname) => {
  if (onlyLastname) {
    const title_split = url.split('/');
    let titleName = null;
    if (title_split?.length > 0) {
      titleName = title_split?.[title_split?.length - 1];
    }
    const final_title = titleName.split('-').join(' ');
    return final_title;
  } else {
    const title_split = url.split('-');
    let string_length_consider = '';
    const title_split_copy = [...title_split];
    if (isNaN(title_split_copy.pop())) {
      string_length_consider = title_split.length;
    } else {
      string_length_consider =
        title_split.length > 1 ? title_split.length - 1 : title_split.length;
    }
    const title_removed_id = title_split.slice(0, string_length_consider);
    const title_removed_hyphen = title_removed_id.join(' ');
    const final_title = title_removed_hyphen.split('/').join(' ');
    return final_title;
  }
};
